import 'css-chunk:src/index/pages/main/index.module.scss';export default {
  "tabs": "tabs__dFHR5",
  "active": "active__hz6FQ",
  "scheduleContainer": "scheduleContainer__bPSwG",
  "modeBtn": "modeBtn__YrjNU",
  "floortabs": "floortabs__pyPTY",
  "divisionSelector": "divisionSelector__dQ8Sm",
  "sectionMain": "sectionMain__3htVN",
  "contentTitle": "contentTitle__k7LY9",
  "date": "date__d-9c6",
  "areaTitle": "areaTitle__pHEVd",
  "dummy_schedule": "dummy_schedule__fJE0V",
  "containerRow1": "containerRow1__VAhL-",
  "containerColumn": "containerColumn__4JU31",
  "containerRow2": "containerRow2__u8iN-",
  "item1": "item1__JwvEI",
  "item2": "item2__vrsai",
  "item3": "item3__Yed5H",
  "item4": "item4__SBZbj",
  "item3Title": "item3Title__O8N1u",
  "summary_items": "summary_items__9MFpe",
  "sectionFloor": "sectionFloor__zFhaV",
  "floorBtns": "floorBtns__PFUFm",
  "map": "map__Z-BMF",
  "floorGroups": "floorGroups__jklJL",
  "robotError": "robotError__oiba3"
};